import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SupportModeService } from '@app/services/support-mode.service';

@Injectable()
export class SupportModeGuard {
  constructor(private router: Router, @Inject(SupportModeService) private supportModeService) {}

  public canActivate(): boolean {
    if (this.supportModeService.inSupportMode) return true;
    this.router.navigate(['/']);
    return false;
  }
}
